// @import dependencies
import React, { CSSProperties, useState } from 'react'
import moment from 'moment';
// @end dependencies

// @import components
import InputComponent from 'app_components/commons/Input/InputComponent';
import ButtonWithLogin from 'app_components/modules/ButtonWithLogin/ButtonWithLogin';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import IconComponent from 'app_components/commons/icons';
// @end components

// @import types
import { ForumMessage } from 'app_types/admin/forum/forumMessageTypes';
import { CombinedReducers } from 'app_events/index';
// @end types

// @import services
import ForumMessageService from 'app_services/admin/forum/forumMessageService';
import LikeService from 'app_services/admin/like/likeService';
// @end services

// @import hooks
import { useSelector } from 'react-redux';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ForumResponseModule.scss'
// @end styles

interface IForumResponseModuleProps {
  className?: string
  style?: CSSProperties
  id?: string
  message: ForumMessage
  subMessages?: ForumMessage[]
  onNewResponse?: (response: any) => void
  onLikeSaved?: (response: any) => void
  onLoginSuccess?: () => void
}

const ForumResponseModule: React.FC<IForumResponseModuleProps> = (props) => {

  const [openInput, updateOpenInput] = useState<boolean>(false);
  const [message, updateMessage] = useState<string>('');
  const [loadingSend, updateLoadingSend] = useState<boolean>(false);
  const user = useSelector((store: CombinedReducers) => store.auth.user)

  // @INFO Servicios
  const forumMessageService = new ForumMessageService();
  const likeService = new LikeService();

  const handleClickResponse = async () => {
    if (openInput) {
      if (!user?.data?.id || !props.message?.forum) return
      // Enviar una respuesta al foro
      updateLoadingSend(true);
      const response = await forumMessageService.sendMessage({
        user: user?.data?.id,
        forum: props.message?.forum,
        forumMessage: props.message._id,
        message
      });
      if (response?.code === 200 && response?.message) {
        if (props.onNewResponse) {
          props.onNewResponse(response.message)
        }
      }
      updateLoadingSend(false);
      updateMessage('');
      updateOpenInput(false);
    } else {
      updateOpenInput(true);
    }
  }

  const handleClickLike = async () => {
    if (!props.message?._id || !user?.data?.id || props.message?.postedLike) return
    const response = await likeService.create({
      forumMessage: props.message?._id,
      user: user?.data?.id
    })
    if (response?.code === 200 && props.onLikeSaved) {
      props.onLikeSaved(response)
    }
  }

  return(
    <div
      className={`forum_response_module-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <ResponseComponent
        message={props.message}
      />
      <hr />
      <div className="container-actions-response">
        <div
          className="container-input-response"
          style={{marginRight: 'auto', width: '100%'}}
        >
          <div className="container-answer-buttons">
            <ButtonWithLogin
              styleButton={{color: '#7C878E', width: 'fit-content'}}
              onClick={() => handleClickResponse()}
              loginText='Es necesario iniciar sesión como docente para crear una respuesta'
              loading={loadingSend}
              disabled={openInput && !message.trim().length}
            >
              Responder
            </ButtonWithLogin>
            {openInput ?
              <ButtonComponent
                variant='tertiary'
                style={{width: 'fit-content'}}
                onClick={() => updateOpenInput(false)}
              >
                Cancelar
              </ButtonComponent>
            :null}
          </div>
          {openInput ?
            <InputComponent
              style={{width: '100%'}}
              placeholder='Escribe tu respuesta...'
              onChange={(e) => updateMessage(e.target.value)}
              value={message}
            />
          :null}
        </div>
        <TextComponent
          type='text'
          style={{color: 'var(--text2)', fontWeight: 300, fontSize: '0.9rem', width: '100px'}}
        >
          {props.message.totalLikes} Voto(s)
        </TextComponent>
        <ButtonWithLogin
          styleButton={{padding: '0px'}}
          loginText='Debes iniciar sesión para indicar que te gusta esta respuesta'
          onLoginSuccess={props.onLoginSuccess}
        >
          <IconComponent
            onClick={handleClickLike}
            svg='Like'
            class_name={`like-message-icon ${props.message?.postedLike ? 'active' : ''}`}
          />
        </ButtonWithLogin>
      </div>
      <div className="container-list-responses-comment">
        {props.subMessages?.length ?
          props.subMessages.map((m) => (
            <ResponseComponent
              message={m}
              key={m._id}
            />
          ))
        : null}
      </div>
    </div>
  );
}

// ================================================
// Componente de respuesta
// ================================================
interface IResponseComponentProps {
  className?: string
  style?: CSSProperties
  id?: string
  message: ForumMessage
}

const ResponseComponent: React.FC<IResponseComponentProps> = (props) => {
  return(
    <div
      className={`response_component-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <img src={props.message?.posted_by?.profile?.avatarImageUrl} alt="" />
      <div>
        <TextComponent
          type='text'
          style={{color: 'var(--primary)', fontWeight: 700}}
        >
          {props.message.posted_by?.profile?.first_name} {props.message.posted_by?.profile?.last_name}
        </TextComponent>
        <TextComponent
          type='text'
          style={{color: 'var(--text2)', fontSize: '0.8rem'}}
        >
          {moment(props.message?.message?.date).format('DD/MM/YYYY')}
        </TextComponent>
        <TextComponent
          type='text'
          style={{color: 'black', fontSize: '0.9rem'}}
        >
          {props.message?.message?.text}
        </TextComponent>
      </div>
    </div>
  );
}


export default ForumResponseModule;
